import { render, staticRenderFns } from "./CallHistory.vue?vue&type=template&id=8145e9f6"
import script from "./CallHistory.vue?vue&type=script&lang=js"
export * from "./CallHistory.vue?vue&type=script&lang=js"
import style0 from "./CallHistory.vue?vue&type=style&index=0&id=8145e9f6&prod&lang=scss"
import style1 from "./CallHistory.vue?vue&type=style&index=1&id=8145e9f6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports